import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/apps/dashboard/src/app/[locale]/error.tsx");
